import styles from './style.styl'
import Section from '../section'

const Apply = () => (
  <Section
    id='apply'
    className={styles.apply}
    title={`DOWNLOAD&nbsp;<br />BROCHURE&nbsp;<br />& APPLY`}
    text={`
    To&nbsp;download the brochure with more information, syllabus and how to&nbsp;apply to&nbsp;the programme, fill in&nbsp;the form below. The earlier you apply, the better chance you will have to&nbsp;join&nbsp;us in&nbsp;2025. The programme starts on&nbsp;July 13th, 2025 and costs &pound;35,000 (excl. VAT) for all 5&nbsp;modules.
    
     <br /><br />
     If you have any questions, email
     <a href='mailto:andrea@futurelondonacademy.co.uk'>
       andrea@futurelondonacademy.co.uk
     </a>
    `}
  />
)

export default Apply



// WEBPACK FOOTER //
// ./components/apply/index.js